import React from 'react';
export function GlobeSpindleIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 2.206a1 1 0 10-1 1.732 7 7 0 01-7 12.124 1 1 0 10-1 1.732 8.97 8.97 0 003.5 1.152V20H7a1 1 0 100 2h8a1 1 0 100-2h-3v-1.055a9 9 0 003.5-16.74zM7 10a4.002 4.002 0 012.814-3.821C9.038 6.995 8.48 7.963 8.1 8.955a10.656 10.656 0 00-.652 2.884A3.983 3.983 0 017 9.999zm2.43 3.341c.874-.544 1.782-1.633 2.405-2.992.614-1.338.838-2.688.625-3.718-1.196.659-2.004 1.762-2.493 3.039a8.72 8.72 0 00-.537 3.671zm2.412.57a4.002 4.002 0 002.668-5.83c-.095 1.07-.418 2.145-.857 3.102-.452.984-1.073 1.946-1.811 2.728zM5 10a6 6 0 1112 0 6 6 0 01-12 0z"
  }));
}